import { useEffect } from "react";

// Bloquea atajos del browser para mantener al cliente dentro de la app.
// NO es seguridad real (Alt+Tab al SO sigue funcionando); la defensa
// fuerte la da Chrome --kiosk o Windows kiosk mode (tarea de IT).
export function useAppFullscreen() {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "F11" || e.key === "F12") {
        e.preventDefault();
      }
      if (
        e.ctrlKey &&
        ["t", "w", "l", "n", "r", "T", "W", "L", "N", "R"].includes(e.key)
      ) {
        e.preventDefault();
      }
    };
    const onContext = (e: MouseEvent) => e.preventDefault();

    document.addEventListener("keydown", onKey);
    document.addEventListener("contextmenu", onContext);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("contextmenu", onContext);
    };
  }, []);
}

// Request fullscreen tras user gesture (browsers exigen click/tap).
export function requestFullscreen() {
  const el = document.documentElement;
  // Promise puede rechazarse si no hay user gesture; ignorar silenciosamente.
  void el.requestFullscreen?.().catch(() => {});
}
